/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
import React from "react";
import { styled } from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const MainContainer = styled.div`
  height: 900px;
  overflow-y: auto;
`;

const EllipsisCell = styled(TableCell)`
  && {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
`;

function GenericTable({ tableData, headers }) {
  const renderTableCell = (row, header) => {
    if (header === "First Cycle" || header === "Second Cycle") {
      return (
        <EllipsisCell
          key={header}
          // colSpan={3}
          sx={{
            borderBottom: row.index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
            borderTop: row.index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
            textAlign: "center",
          }}
        >
          {/* {row[header]?.name && (
            <span>
              Name: {row[header]?.name}, No. of Members: {row[header].contributedMembers}, Amount: {row[header].amount}
            </span>
          )} */}
          <p>Name: {row[header]?.name}</p>
          <p>No. of Members: {row[header].contributedMembers}</p>
          <p>Amount: {row[header].amount}</p>
        </EllipsisCell>
      );
    }
    return (
      <EllipsisCell
        key={header}
        sx={{
          textAlign: "center",
        }}
      >
        {row.hasOwnProperty(header) ? (
          <span>{row[header]}</span>
        ) : (
          <span>N/A</span>
        )}
      </EllipsisCell>
    );
  };

  return (
    <MainContainer>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                background:
                  "linear-gradient(180deg, #2A93C1 0%, #1D7196 87.50%, #BCD4DE 100%)",
                // width: "100%"
              }}
            >
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? "#E8F6FC" : "#ffffff" }}
              >
                {headers.map((header) => renderTableCell(row, header))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MainContainer>
  );
}

export default GenericTable;
